<template lang="pug">
span#reports
  div.graph-wrapper
    div(style='width: 50%; margin-bottom: 40px;')
      label.graph-title Omni Administrator Graph API
    div.graph-content
      md-card
        md-card-header.md-card-header-icon.md-card-header-green
          div.card-icon
            DomainVerification
        md-card-content
          div(style='flex-direction: column; display: flex; padding: 26px;')
            label.graph-title-bold {{ $t('recoveryTeams.finishedInstall') }}
            label.graph-title {{ $t('recoveryTeams.youAreInGraphApi') }}
            br
            label.graph-title-desc {{ $t('recoveryTeams.thanksForInformation') }}
</template>
<script>
import DomainVerification from '@/assets/img/domain_verification.svg'
export default {
  components: {
    DomainVerification
  }
}
</script>
<style lang="scss">
.graph-title {
  font-weight: 400;
  text-align: left;
  font-size: 20px;
  color: #181818;
}
.graph-title-desc {
  text-align: left;
  font-size: 14px;
  color: #181818;
  font-weight: 400;
  margin-bottom: 30px;
}
.graph-title-bold {
  margin-bottom: 10px;
  font-weight: 500;
  text-align: left;
  font-size: 30px;
  color: #000000;
}
.graph-wrapper {
  padding-block: 50px;
  flex-direction: column;
  align-items: center;
  display: flex;
  height: 100%;
}
.graph-content {
  width: 50%;
}
</style>
